exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-52dca69c] #anniversary25-modal___BV_modal_content_{background:#1191a7;color:#fff;text-align:center}[data-v-52dca69c] #anniversary25-modal___BV_modal_content_ #anniversary25-modal___BV_modal_header_{text-align:center;display:block;border:none;padding:.2rem .5rem 0 0}[data-v-52dca69c] #anniversary25-modal___BV_modal_content_ #anniversary25-modal___BV_modal_footer_{display:none}", ""]);

// exports
